module.exports = __webpack_public_path__ + "img/my2-icon.db665b67.png";